import React, {useMemo} from 'react';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faChevronLeft, faMapPin, faMagnifyingGlass} from "@fortawesome/free-solid-svg-icons";
import {useLocation, useNavigate, useParams} from "react-router-dom";
import type {HotspotExplorerProps} from "../types";
import {buildCountryPath, findHotspotByLocationId, getCountryLabel} from "../helpers";
import './hotspot-detail.scss';

export function HotspotDetailView({hotspotExplorerIndex}: HotspotExplorerProps) {
    const navigate = useNavigate();
    const location = useLocation();
    const {locationId = ''} = useParams();
    const hotspots = hotspotExplorerIndex.hotspots;
    const hotspot = useMemo(() => findHotspotByLocationId(hotspots, locationId), [hotspots, locationId]);
    const returnTo = (location.state as {returnTo?: string} | null | undefined)?.returnTo || buildCountryPath(hotspot?.countryCode || 'US');

    return (
        <section className="hotspot-detail">
            <button type="button" className="hotspot-detail__back" onClick={() => navigate(returnTo)}>
                <FontAwesomeIcon icon={faChevronLeft} aria-hidden="true" />
                Back
            </button>
            <div className="hotspot-detail__card">
                <p className="hotspot-detail__eyebrow">
                    <FontAwesomeIcon icon={faMapPin} aria-hidden="true" />
                    Hotspot Detail
                </p>
                <h1>{hotspot?.location ?? 'Hotspot Detail'}</h1>
                <p className="hotspot-detail__intro">
                    This view is a stub for the hotspot detail page. I’ll wire the full detail layout in the next pass.
                </p>

                {hotspot ?
                    <dl className="hotspot-detail__summary">
                        <div>
                            <dt>Location</dt>
                            <dd>{hotspot.countyLabel}, {hotspot.stateLabel}, {getCountryLabel(hotspot.countryCode)}</dd>
                        </div>
                        <div>
                            <dt># of visits</dt>
                            <dd>{hotspot.visits.toLocaleString()}</dd>
                        </div>
                        <div>
                            <dt>Species seen</dt>
                            <dd>{hotspot.speciesSeen.toLocaleString()}</dd>
                        </div>
                        <div>
                            <dt>Last visited</dt>
                            <dd>{hotspot.lastVisited || '--'}</dd>
                        </div>
                    </dl>
                    : null
                }

                <div className="hotspot-detail__stub">
                    <FontAwesomeIcon icon={faMagnifyingGlass} aria-hidden="true" />
                    Detail content coming next.
                </div>
            </div>
        </section>
    );
}
